const Badge = {
   baseStyle: {
      borderRadius: 'md',
      display: 'inline-flex',
      fontSize: 'md',
      fontWeight: 'semibold',
      paddingInline: `6px`,
      placeItems: 'center',
      textTransform: 'normal',
   },
   sizes: {
      tiny: {
         fontSize: '10px',
         height: '20px',
      },
   },
};

export default Badge;
